import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import SubscribeCard from "./subscribeCard";
import "./subscribes.scss";

const Subscribes = (props) => {
  const imgBaseURL = `${process.env.REACT_APP_API_BASE_URL}/blob-assets/images/illustrations/community-standup`;
  const youtubeLogo = imgBaseURL +`/youtube-logo.svg`;
  const youtubeLogoDark = imgBaseURL +`/youtube-logo-dark.png`;
  const twitchLogo = imgBaseURL +`/twitch.svg`;
  const twitchLogoDark = imgBaseURL +`/twitch-dark.svg`;

  const { youtubeLink, twitchLink } = props;
  // useState to hold state of cookie
  const [theme, setTheme] = useState(localStorage.getItem("theme"));

  useEffect(() => {
    const messageEventHandler = (event) => {
      if (event.data && typeof event.data === "object" && "setTheme" in event.data) {
        setTheme(() => { return event.data.setTheme; });
      }
    };

    // add postMessage listner
    window.addEventListener("message", messageEventHandler);
    //remove postMessage listner
    return () => {
      window.removeEventListener('message', messageEventHandler);
    };
  }, []);

  return (
    <div className="subscribes row justify-content-center align-items-center pt-40">
      {
        youtubeLink &&
        (
          <SubscribeCard
            url={youtubeLink}
            iconSrc={theme === "dark" ? youtubeLogoDark : youtubeLogo}
            altText="On Dot NET Live playlist on YouTube"
          />
        )
      }
      {
        twitchLink &&
        (
          <SubscribeCard
            url={twitchLink}
            iconSrc={theme === "dark" ? twitchLogoDark : twitchLogo}
            altText="Visual Studio channel on Twitch"
          />
        )
      }
    </div>
  );
};

Subscribes.propTypes = {
  youtubeLink: PropTypes.string.isRequired,
  twitchLink: PropTypes.string.isRequired
};

export default Subscribes;
